<template>
	<div class="mt-2 v-text-field__details">
		<div class="v-messages theme--light" :class="{ 'error--text': error }" role="alert">
			<div class="v-messages__wrapper">
				<div class="v-messages__message">{{ $slots.default[0].text }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'VTextFieldDetails',
	props: {
		error: Boolean,
		message: {
			type: String,
			default: ''
		}
	}
};
</script>
